import React from 'react'
import TrainingBanner from '../Training/TrainingBanner'
import ServiceDemand from '../service/ServiceDemand'
import InstalllationAssessment from './InstalllationAssessment';
import HealthcareFacility from '../../Industries/Healthcare/HealthcareFacility';
import TrainingServiceWork from '../Training/TrainingServiceWork';
import InstallationTab from './InstallationTab';
import HealthcareFaq from '../../Industries/Healthcare/HealthcareFaq';
import InstallationService from './InstallationService';

export default function Installation() {

    const Banner = {
        image: "/assets/images/commercial-banner.webp",
        heading: "Your Equipment Deserves More Than A Delivery Drop.",
        description: "Supershine installations cover the full process, from site preparation and equipment positioning to connection testing and operator handover, ensuring your facility is ready to run at full capacity immediately.",
        buttonText: "Get Started Today",
        link: "/contact",
    }

    const ServiceFaq = {
        heading: "What Poor Installation Costs You Later",
        description: "Cutting corners at the installation stage does not save time or money. It creates a set of problems that compound quietly until they become expensive to fix.",
        image: "/assets/images/matters-img.webp",
        alt: "Teenager Smiling",
        faqs: [
            {
                question: "Warranty Protection Risks",
                answer: "Most equipment warranties require professional installation by a qualified team. Improper setup, even something as minor as incorrect levelling or wrong utility connections, can void your warranty before the machine runs a single cycle.",
            },
            {
                question: "Premature Equipment Failure",
                answer: "Machines installed without correct calibration and load balancing experience accelerated wear on bearings, motors, and suspension components, leading to breakdowns far earlier than the equipment's designed lifespan.",
            },
            {
                question: " Inconsistent Performance From The Start",
                answer: "Incorrect water pressure, drainage, or electrical connections result in machines that never reach their rated capacity, costing you output and efficiency from day one without an obvious cause.",
            },
            {
                question: "Compliance And Code Issues",
                answer: "Industrial laundry equipment must meet specific utility, safety, and building code requirements. Non-compliant installations create liability exposure and can trigger costly remedial work during inspections.",
            },
            {
                question: "Reduced Equipment Lifespan",
                answer: "Every hour a machine runs on an incorrect installation adds stress it was not designed to handle. The cumulative effect is a significantly shorter operational life and higher total cost of ownership.",
            },
        ],

    };

    const assessmentData = [
        {
            title: "Electrical Load And Panel Review",
            description:
                "We verify your existing electrical capacity, wiring condition, and panel configuration against the power demands of each machine to ensure safe, stable operation from the first switch-on.",
            image: "/assets/images/electrical-img1.webp",
        },

        {
            title: "Water Supply And Drainage Assessment",
            description:
                "We measure inlet pressure, flow rate, and drainage capacity to ensure your water system supports the machines efficiently and runs smoothly. We also suggest improvements to prevent future issues.",
            image: "/assets/images/electrical-img2.webp",
        },
        // {
        //     title: "Floor Strength And Surface Levelling",
        //     description:
        //         "We inspect the floor surface, load-bearing capacity, and levelness of the installation area to prevent vibration issues, ensure machine stability, and protect both the equipment and the building structure.",
        //     image: "/assets/images/electrical-img3.webp",
        // },
        {
            title: "Venting And Exhaust Assessment",
            description:
                "We check exhaust routing, duct sizing, and ventilation capacity to ensure dryers can expel heat and moisture efficiently without creating airflow restrictions that reduce drying performance.",
            image: "/assets/images/electrical-img4.webp",
        },
        {
            title: "Drain Line Inspection",
            description: "We inspect existing drain lines for diameter, gradient, and condition to confirm they can handle the discharge volume of the machines being installed without backing up or causing floor flooding.",
            image: "/assets/images/electrical-img5.webp",

        },
        {
            title: "Gas Line Verification",
            description: "We check gas supply pressure, pipe sizing, and connection points against the rated requirements of each appliance to ensure safe, code-compliant gas installation before any equipment is connected.",
            image: "/assets/images/electrical-img6.webp",
        },
    ];

    const Service = {
        heading: "How Supershine <br>  Manages   Every Installation",
        image: "/assets/images/install-service.webp",
        alt: "Teenager Smiling",
        faqs: [
            {
                number: "01",
                question: "Site Planning And Delivery",
                answer: "We coordinate delivery logistics, access routes, and floor placement in advance so equipment arrives on schedule and reaches its installation position without damage or delay.",
            },
            {
                number: "02",
                question: "Utility Connections Setup",
                answer: "Our technicians handle all water, drainage, electrical, and steam connections precisely to manufacturer specifications, ensuring every utility is correctly configured before the machine is powered on.",
            },
            {
                number: "03",
                question: "Positioning And Installation",
                answer: "Equipment is positioned, levelled, and secured according to site assessment findings, with anti-vibration measures applied where required to ensure stable long-term operation.",
            },
            {
                number: "04",
                question: "Testing And Handover",
                answer: "Every machine is run through a full test cycle before handover. We verify performance, check all connections under load, and walk your team through basic operation before leaving the site.",
            },
        ],

    };

    const facilityData = {
        title: "Equipment We Install And Commission",
        description: "From single machines to full facility setups, every installation is handled with the same level of care and technical precision regardless of equipment type or scale.",
        items: [
            {
                icon: "/assets/images/washer-img1.webp",
                heading: "Washer Extractors",
                description: "Installed with correct levelling, suspension setup, and utility connections to ensure stable operation, full extraction performance, and minimum vibration from the first cycle."
            },
            {
                icon: "/assets/images/washer-img2.webp",
                heading: "Tumble Dryers",
                description: "Positioned and connected with exhaust routing, electrical load, and airflow requirements verified so drying performance matches the machine's rated capacity from day one."
            },
            {
                icon: "/assets/images/washer-img3.webp",
                heading: "Compact Units",
                description: "Mounted, secured, and connected with structural support requirements confirmed in advance to ensure safe long-term operation in space-constrained environments."
            },
            {
                icon: "/assets/images/washer-img4.webp",
                heading: "Laundromat Systems",
                description: "Full setup including machine positioning, utility connections, and payment system integration to ensure the facility is fully ready for customer use before opening day."
            },
            {
                icon: "/assets/images/washer-img5.webp",
                heading: "Industrial Equipment",
                description: "Heavy-duty machines installed to exact manufacturer specifications with load capacity, utility demands, and structural requirements all verified before commissioning begins."
            },
            {
                icon: "/assets/images/washer-img6.webp",
                heading: "Finishing Equipment",
                description: "Ironers, presses, and folding units installed with precise alignment and utility connections to deliver consistent finishing output and smooth workflow integration from the start."
            }
        ]
    };
    const TrainingFaq = {
        heading: " Testing, Verification <br> And Team Handover",
        image: "/assets/images/insttalation-img.webp",
        alt: "Teenager Smiling",
        faqs: [
            {
                question: "Installation Testing And Staff Training",
                answer: "Your team is walked through operation, maintenance checks, and early warning signs before we hand over the machine.",
            },
            {
                question: "System Verification",
                answer: "Every utility connection is tested under real load to confirm the machine performs to rated specification.",
            },
            {
                question: "Safety Inspections",
                answer: "Electrical connections, door interlocks, and emergency stop functions are checked and confirmed before handover.",
            },
            {
                question: "Precision Installation",
                answer: "Equipment is levelled, anchored, and aligned to manufacturer tolerances with anti-vibration measures applied throughout.",
            },
        ],

    };

    const faqData = {
        title: "FAQs",
        description:
            "Straight answers about our installation process so you know exactly what to expect.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: " What Does A Supershine Installation Cover?",
                answer: "Everything from pre-installation site assessment and utility verification through to equipment positioning, connection, calibration, and first-run testing. We do not leave until the machine is running correctly and your team knows how to operate it.",
            },
            {
                question: "How Long Does A Typical Installation Take?",
                answer: "Single machine installations are usually completed within a day. Larger multi-machine setups depend on site complexity and utility readiness but are always planned in advance to minimise disruption to your facility's operations.",
            },
            {
                question: "Do We Need To Prepare Anything Before Your Team Arrives?",
                answer: "We handle the assessment and tell you exactly what needs to be in place before installation day. If utility upgrades or floor preparation are required, we identify those well in advance so there are no last-minute surprises.",
            },

            {
                question: " What Happens If A Problem Is Found On Installation Day?",
                answer: "Our pre-installation assessment is designed to catch problems before the team arrives on site. In the rare case something unexpected comes up, our engineers are equipped to address most issues without rescheduling the installation.",
            },

            {
                question: " Is The Equipment Tested Before You Hand Over?",
                answer: "Yes. Every machine is run through a full test cycle under real operating conditions before handover. We check all connections, verify performance output, and confirm the machine is operating within specification before we leave.",
            },

            {
                question: "Do You Provide Operator Guidance After Installation?",
                answer: " Yes. Once testing is complete, we walk your team through equipment operation, basic maintenance checks, and what to look out for in the early running period so your operators start with confidence.",
            },
        ],
    };

    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/installation",
                name: "Installation"
            }
        ]
    }

    return (
        <>
            <TrainingBanner data={Banner} breadcrumb={bannerData.breadcrumb} />
            <ServiceDemand data={ServiceFaq} />
            <InstalllationAssessment data={assessmentData} />
            <InstallationService data={Service} />
            <HealthcareFacility data={facilityData} />
            <TrainingServiceWork data={TrainingFaq} />
            <InstallationTab />
            <HealthcareFaq data={faqData} />
        </>
    )
}
